import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
// import { RouterLink } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { EmployeeDependantsModalComponent } from '../../components/employee-dependants-modal/employee-dependants-modal.component';
import { EmployeesPageChangedEvent } from '../../components/employee-table/employee-table.component';
import { EmployeeTableComponent } from '../../components/employee-table/employee-table.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '@shared/enums/permission.enum';
import { EmployeeResponse } from '../../employee.model';
import { EmployeeStore } from '../../employee.store';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";
import { SHARED_UTILS } from '@shared/modules/shared-utils.module';

@Component({
  selector: 'app-employee-list-page',
  imports: [ EmployeeTableComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './employee-list.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmployeeListPage {
  protected readonly employeeStore = inject(EmployeeStore);
  private readonly dialog = inject(MatDialog);
  protected readonly utils = SHARED_UTILS();

  private readonly permissionService = inject(PermissionService);

  protected readonly actionEmployeeId = signal<string | null>(null);

  constructor() {
    this.employeeStore.loadEmployees();
  }

  protected canCreate(): boolean {
    return this.permissionService.hasPermission(Permission.EmployeesCreate);
  }

  protected canImport(): boolean {
    return this.permissionService.hasPermission(Permission.EmployeesCreate);
  }

  protected canUpdate(): boolean {
    return this.permissionService.hasPermission(Permission.EmployeesUpdate);
  }

  protected canDeactivate(): boolean {
    return this.permissionService.hasPermission(Permission.EmployeesDelete);
  }

  protected canActivate(): boolean {
    return this.permissionService.hasPermission(Permission.EmployeesUpdate);
  }

  protected refresh(): void {
    this.employeeStore.loadEmployees();
  }

  protected searchEmployees(search: string): void {
    this.employeeStore.loadEmployees(
      {
        pageNumber: 1,
        pageSize: this.employeeStore.employeesPageSize(),
      },
      search,
    );
  }

  protected changePage(event: EmployeesPageChangedEvent): void {
    this.employeeStore.loadEmployees({
      pageNumber: event.pageNumber,
      pageSize: event.pageSize,
    });
  }

  protected toggleEmployeeActive(employee: EmployeeResponse): void {
    this.actionEmployeeId.set(employee.id);

    const complete = () => {
      this.employeeStore.loadEmployees();
      this.actionEmployeeId.set(null);
    };

    if (employee.isActive) {
      if (!this.canDeactivate()) {
        this.actionEmployeeId.set(null);
        return;
      }

      this.employeeStore.deactivateEmployee(employee.id, complete);
      return;
    }

    if (!this.canActivate()) {
      this.actionEmployeeId.set(null);
      return;
    }

    this.employeeStore.activateEmployee(employee.id, complete);
  }

  protected openDependantsManagement(employee: EmployeeResponse): void {
    const dialogRef = this.dialog.open(EmployeeDependantsModalComponent, {
      width: '1000px',
      maxWidth: '95vw',
    });

    dialogRef.componentRef?.setInput('employeeId', employee.id);
    dialogRef.componentRef?.setInput('employeeDisplayName', `${employee.firstName} ${employee.surname}`.trim());
    dialogRef.componentRef?.setInput('canManage', this.canUpdate());
  }
}